export default [
    'Ижевск. Октябрьский',
    'Ижевск. Устиновский',
    'Ижевск. Индустриальный',
    'Ижевск. Ленинский',
    'Ижевск. Первомайский',
    'Удмуртская Республика. Воткинск',
    'Удмуртская Республика. Глазов',
    'Удмуртская Республика. Можга',
    'Удмуртская Республика. Сарапул',
    'Удмуртская Республика. Алнашский район',
    'Удмуртская Республика. Балезинский район',
    'Удмуртская Республика. Вавожский район',
    'Удмуртская Республика. Воткинский район',
    'Удмуртская Республика. Глазовский район',
    'Удмуртская Республика. Граховский район',
    'Удмуртская Республика. Дебесский район',
    'Удмуртская Республика. Завьяловский район',
    'Удмуртская Республика. Игринский район',
    'Удмуртская Республика. Камбарский район',
    'Удмуртская Республика. Каракулинский район',
    'Удмуртская Республика. Кезский район',
    'Удмуртская Республика. Кизнерский район',
    'Удмуртская Республика. Киясовский район',
    'Удмуртская Республика. Красногорский район',
    'Удмуртская Республика. Малопургинский район',
    'Удмуртская Республика. Можгинский район',
    'Удмуртская Республика. Сарапульский район',
    'Удмуртская Республика. Селтинский район',
    'Удмуртская Республика. Сюмсинский район',
    'Удмуртская Республика. Увинский район',
    'Удмуртская Республика. Шарсканский район',
    'Удмуртская Республика. Юкаменский район',
    'Удмуртская Республика. Якшур-Бодьинский район',
    'Удмуртская Республика. Ярский район'
]